import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import { useFeedBack } from "../../../context/FeedBackContext";

const ZonesBiCreate = () => {

    const entity = {
        name: 'Zona BI',
        url: 'zones-bi',
        frontendUrl: '/zonas-bi',
    };

    const navigate = useNavigate();
    const [data, setData] = useState({ name: '' });
    const { setLoading, setCustomAlert } = useFeedBack();

    const [{ data: createData, loading }, createRecord] = useAxios(
        { url: `/${entity.url}`, method: 'POST' },
        { manual: true, useCache: false }
    );

    useEffect(() => {
        setLoading({
            show: loading,
            message: 'Guardando Zona...'
        });
    }, [loading]);

    useEffect(() => {
        if (createData) {
            setCustomAlert({
                show: true,
                severity: 'success',
                title: 'Operación Exitosa',
                message: 'La Zona fue creada exitosamente.'
            });
            navigate(`${entity.frontendUrl}/listar`);
        }
    }, [createData]);

    const handleChange = (e) => {
        setData((oldData) => ({
            ...oldData,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = (e) => {
        e?.preventDefault();
        createRecord({ data });
    };

    return (
        <div>
            <div className="my-4 align-items-center justify-content-between d-flex">
                <h3>Crear {entity.name}</h3>
                <Link to={`${entity.frontendUrl}/listar`} className="btn btn-primary">
                    Volver al listado
                </Link>
            </div>

            <form className="card p-4" onSubmit={handleSubmit}>
                <div className="form-group mb-3 col-md-6">
                    <label className="text-primary fw-bold mb-2">
                        Nombre de la Zona <small className="text-danger">*</small>
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={data.name}
                        onChange={handleChange}
                        placeholder="Ej: Zona Norte, Zona Sur, etc."
                        required
                    />
                </div>
                <div className="mt-3">
                    <button className="btn btn-primary">Crear</button>
                </div>
            </form>
        </div>
    );
};

export default ZonesBiCreate;
